/* eslint-disable no-useless-escape */
import { getDeviceId} from './utils/clientInfo';

export function generateDeviceFlags() {
  return {
    appVersion: '20250327',
    deviceId: getDeviceId(),
  };
}
